import { useT } from "@/i18n/locale-context";

export type UserAction = { kind: string; label: string };

const ACTION_LIBRARY: Array<{ kind: string; key: string }> = [
  { kind: "haircut", key: "notes.action.haircut" },
  { kind: "shave", key: "notes.action.shave" },
  { kind: "new_cream", key: "notes.action.new_cream" },
  { kind: "sun_exposure", key: "notes.action.sun" },
  { kind: "treatment", key: "notes.action.treatment" },
  { kind: "makeup", key: "notes.action.makeup" },
  { kind: "filter_off", key: "notes.action.filter_off" },
  { kind: "poor_sleep", key: "notes.action.poor_sleep" },
  { kind: "workout", key: "notes.action.workout" },
  { kind: "alcohol", key: "notes.action.alcohol" },
];

interface Props {
  notes: string;
  onNotesChange: (v: string) => void;
  actions: UserAction[];
  onActionsChange: (next: UserAction[]) => void;
  disabled?: boolean;
  className?: string;
}

export function NotesAndActionsField({
  notes,
  onNotesChange,
  actions,
  onActionsChange,
  disabled,
  className,
}: Props) {
  const t = useT();
  const has = (kind: string) => actions.some((a) => a.kind === kind);
  const toggle = (kind: string, label: string) => {
    if (has(kind)) onActionsChange(actions.filter((a) => a.kind !== kind));
    else onActionsChange([...actions, { kind, label }]);
  };
  return (
    <div className={`bg-card border border-foreground/10 rounded-2xl p-4 ${className ?? ""}`}>
      <p className="text-xs font-bold uppercase tracking-widest text-muted-foreground mb-2">
        {t("notes.title")}
      </p>
      <p className="text-xs text-muted-foreground mb-3">{t("notes.help")}</p>
      <div className="flex flex-wrap gap-2 mb-3">
        {ACTION_LIBRARY.map(({ kind, key }) => {
          const label = t(key);
          const active = has(kind);
          return (
            <button
              key={kind}
              type="button"
              disabled={disabled}
              onClick={() => toggle(kind, label)}
              className={`px-3 py-1.5 rounded-full text-xs font-semibold border transition-colors ${
                active
                  ? "bg-accent text-accent-foreground border-accent"
                  : "bg-background text-foreground border-foreground/15 hover:border-foreground/40"
              }`}
            >
              {active ? "✓ " : "+ "}
              {label}
            </button>
          );
        })}
      </div>
      <textarea
        value={notes}
        onChange={(e) => onNotesChange(e.target.value)}
        disabled={disabled}
        rows={3}
        maxLength={2000}
        placeholder={t("notes.placeholder")}
        className="w-full rounded-xl border border-foreground/15 bg-background p-3 text-sm focus:outline-none focus:border-accent"
      />
      <p className="text-[10px] text-muted-foreground mt-1 text-right">{notes.length} / 2000</p>
    </div>
  );
}